export default __webpack_public_path__ + "static/media/d to d.3009782a.svg";